import { EnvironmentProviders } from '@angular/core';
import {
  HttpInterceptorFn,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import { headerInterceptor } from './header.interceptor';
import { loadingInterceptor, SKIP_GLOBAL_SPINNER } from './loading.interceptor';
import { errorInterceptor, SessionExpiredError } from './error.interceptor';

export {
  headerInterceptor,
  loadingInterceptor,
  errorInterceptor,
  SessionExpiredError,
  SKIP_GLOBAL_SPINNER,
};

/**
 * Helper to provide data-access HTTP interceptors in an application (call once in app config).
 *
 * @param appInterceptors App-specific interceptors. They run outermost, so they
 * see errors after `errorInterceptor` has processed them (e.g. `SessionExpiredError`).
 */
export function provideDataAccessHttp(
  ...appInterceptors: HttpInterceptorFn[]
): EnvironmentProviders {
  return provideHttpClient(
    withInterceptors([
      ...appInterceptors,
      headerInterceptor,
      loadingInterceptor,
      errorInterceptor,
    ]),
  );
}
